module.exports = __webpack_public_path__ + "media/YEAH_Scribble_Kopf_Arne_480x480.dea94292.mp4";